"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleReplicaApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleReplicaApiClient(networkClient) {
    return {
        listCampaigns: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns`, query, config);
        },
        listCampaignSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns/snapshots`, query, config);
        },
        listAdGroups: async (params, query, config) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups`, query, config);
        },
        listAdGroupSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/snapshots`, query, config);
        },
        listAdGroupTargetingKeywords: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords`, query, config);
        },
        listAdGroupTargetingKeywordSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords/snapshots`, query, config);
        },
        listAdGroupNegativeKeywords: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/negative-keywords`, query, config);
        },
        listAdGroupNegativeKeywordSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/negative-keywords/snapshots`, query, config);
        },
        listCampaignNegativeKeywords: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/negative-keywords`, query, config);
        },
        listCampaignNegativeKeywordSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/negative-keywords/snapshots`, query, config);
        },
        listCampaignReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns/reports`, query, config);
        },
        listAds: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ads`, query, config);
        },
        listAdSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ads/snapshots`, query, config);
        },
        listProductPages: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/product-pages`, query, config);
        },
        listProductPageSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/product-pages/snapshots`, query, config);
        },
        listProductPageLocales: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/product-page-locales`, query, config);
        },
        listProductPageLocaleSnapshots: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/product-page-locales/snapshots`, query, config);
        },
        getCampaignReportSummary: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns/reports/summary`, query);
        },
        getCampaignReportGrouping: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns/reports/grouping`, query);
        },
        getAdGroupReportSummary: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/reports/summary`, query);
        },
        getAdGroupReportGrouping: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/reports/grouping`, query);
        },
        listAdGroupReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/reports`, query, config);
        },
        getAdGroupTargetingKeywordReportGrouping: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords/reports/grouping`, query);
        },
        getAdGroupTargetingKeywordReportSummary: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords/reports/summary`, query);
        },
        getAdGroupTargetingKeywordBidsInfo: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords/bids-info`, query, config);
        },
        listAdGroupTargetingKeywordReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ad-groups/targeting-keywords/reports`, query, config);
        },
        getSearchTermReportSummary: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/search-terms/reports/summary`, query);
        },
        getSearchTermReportGrouping: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/search-terms/reports/grouping`, query);
        },
        listSearchTermReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/search-terms/reports`, query, config);
        },
        getAdReportSummary: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ads/reports/summary`, query);
        },
        getAdReportGrouping: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ads/reports/grouping`, query);
        },
        listAdReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/ads/reports`, query, config);
        },
        updateReferences: async (body) => {
            return networkClient.postHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/admin/update-references`, body);
        },
        listCustomReports: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/custom-report`, query, config);
        },
        replicate: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/campaigns/${params.campaignId}/replicate`, body);
        },
        getApplicationOptions: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/api/v2/apple-replica/teams/${params.teamId}/options/application`, query);
        },
    };
}
exports.appleReplicaApiClient = appleReplicaApiClient;
